// src/pages/NotFound.js // Assuming it's moved to pages
import React from 'react';
import { Link } from 'react-router-dom';
// ACTION: Verify path to CSS is correct
import './NotFound.css'; // Assumed CSS is in the same folder

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1 className="not-found-heading">404</h1>
        <h2 className="not-found-subheading">Página no encontrada</h2>
        <p className="not-found-message">
          Lo sentimos, la página que buscas no existe o ha sido movida.
        </p>
        <Link to="/" className="not-found-button">
          Volver al Inicio
        </Link>
      </div>
    </div>
  );
};

export default NotFound;